import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { CustomModalBodyDirective } from '@shared/components/modal-confirmation/modal-confirmation.component';
import { ModalConfirmationModule } from '@shared/components/modal-confirmation/modal-confirmation.module';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LaddaModule } from 'angular2-ladda';
import { DeviceType } from '@shared/models/common.model';
import { ThemeService } from '@shared/service/theme.service';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-modal-confirmation-std-mobile-header',
  standalone: true,
  imports: [
    CommonModule,
    LaddaModule,
    ModalConfirmationModule,
    TranslateModule,
    FontAwesomeModule,
  ],
  templateUrl:
    './modal-confirmation-std-mobile-header.component.html',
  styleUrls: [
    './modal-confirmation-std-mobile-header.component.scss',
  ],
  providers: [CustomModalBodyDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalConfirmationStdMobileHeaderComponent {
  @Input() dismissText?: string;
  @Input() header?: string;
  @Input() isSubmitDisabled = false;
  @Input() isLoading = false;
  @Input() submitText?: string;
  @Input() subtitle?: string;
  @Input() title?: string;
  @Input() hideButton = false;
  @Input() headerCloseButton = false;
  @Output() dismiss = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<void>();
  @ContentChild(TemplateRef)
  templateRef: TemplateRef<unknown>;

  deviceType: DeviceType = 'desktop';

  constructor(private themeService: ThemeService) {
    this.deviceType = this.themeService.getDeviceTypeByBreakpoint();
  }

  onDismissClick(): void {
    this.dismiss.emit();
  }

  onSubmitClick(): void {
    this.submitted.emit();
  }
}
